module.exports = __webpack_public_path__ + "img/trip_sendai09.5756132c.jpg";